module.exports = __webpack_public_path__ + "static/media/kernelcon_logo.94496763.svg";